import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import router from './router';
import store from './store';
import './scss/style.scss';
import Vuex from 'vuex';
import VueAxios from 'vue-axios';
import axios from 'axios';
import VueScrollTo from 'vue-scrollto';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Notifications from 'vue-notification';
import VueRouterBackButton from 'vue-router-back-button';
import de from './locales/de.json';
import config from './config';
// import './scss/style-rtl.scss';


// import "vue-select/dist/vue-select.css";

Vue.config.productionTip = true;
Vue.prototype.modals = true;
export const bus = new Vue({});

/* Centralized app configuration (single source of truth: .env/.env.example via config.js) */
Vue.prototype.$appId = config.appId;
Vue.prototype.$appName = config.appName;
Vue.prototype.$institutionId = config.institutionId;
Vue.prototype.$offerId = config.offerId;
Vue.prototype.$city = config.defaultCity;
Vue.prototype.$backendUrl = config.baseUrl;
Vue.prototype.$backendApiUrl = config.apiBaseUrl;
Vue.prototype.$impressumContentId = config.impressumContentId;
Vue.prototype.$datenschutzContentId = config.datenschutzContentId;
Vue.prototype.$barrierefreiheitsContentId = config.barrierefreiheitContentId;
Vue.prototype.$shortDescriptionWordCount = config.shortDescriptionWordCount;

Vue.use(Vuex);
Vue.use(VueI18n)
Vue.use(VueScrollTo);
Vue.use(Notifications);
Vue.use(VueAxios, axios);
Vue.use(VueRouterBackButton, { router });

const i18n = new VueI18n({
  locale: 'de',
  messages: {
    de,
  }
})

/*Initialisieren von Loading*/
Vue.use(Loading, {
  color: 'rgb(148, 192, 31)',
  loader: 'dots',
  width: 140,
  FullPage: true
});

new Vue({
  i18n,
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
